import SubmissionPage from "./SubmissionPage";

export default SubmissionPage;
